export default "__VITE_ASSET__CFKrUP7V__"